export function simulateWheel(deltaY: number) {
  const evt = document.createEvent("MouseEvents");
  evt.initEvent("wheel", true, true);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  evt.deltaY = deltaY;
  const els = document.getElementsByTagName("canvas");
  if (els.length > 0) {
    els[0].dispatchEvent(evt);
  }
}
